import PropTypes from 'prop-types';
import React, {Component} from 'react';
import Navigation from '~/components/Navigation/Navigation';
import style from './style.css';
import ElementTooltipContainer from "~/components/Tooltip/ElementTooltipContainer";

export default class Pagination extends Component {
    static propTypes = {
        currentPage: PropTypes.number.isRequired,
        total: PropTypes.number.isRequired,
        perPage: PropTypes.number.isRequired,
        onPageChange: PropTypes.func.isRequired,
        maxPages: PropTypes.number.isRequired,
        tooltip: PropTypes.string,
    };

    static defaultProps = {
        maxPages: 5
    };

    getNavigationItems = () => {
        const navigation = [],
            currentPage = this.props.currentPage,
            maxPages = this.props.maxPages;

        if(this.props.total <= this.props.perPage) {
            return [{ label: '1', clickArgs: [1]}];
        }

        currentPage < 2 || navigation.push({ label: '<', clickArgs: [currentPage - 1] });

        let pagesCount = Math.ceil(this.props.total / this.props.perPage),

            start = Math.max(currentPage - (Math.ceil(maxPages / 2) -1), 1) - 1,
            end = Math.min(pagesCount, currentPage + (maxPages-(currentPage-start)));

        start = Math.max(0, Math.min((currentPage - (maxPages - (end - currentPage))), start));

        for(let i = start; i < end; i++) {
            let page = i+1;

            navigation.push({ label: page.toString(), clickArgs: [page], active: page === currentPage });
        }

        if(end < pagesCount) {
            navigation.push({ label: '...', clickArgs: [], separator: true });
            navigation.push({ label: pagesCount.toString(), clickArgs: [pagesCount]});
        }

        if(currentPage < pagesCount) {
            navigation.push({ label: '>', clickArgs: [currentPage + 1] });
        }

        return navigation;
    };

    render() {
        const { tooltipsActive, total } = this.props;

        return (
            <ElementTooltipContainer leftMargin tooltip={this.props.tooltip} active={tooltipsActive && total > 0}>
                <Navigation
                    data={this.getNavigationItems()}
                    handleClick={this.props.onPageChange}
                    className={style.navigation}
                />
            </ElementTooltipContainer>
        );
    }
};